/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Autowired, Bean, GetRowNodeIdFunc, GridOptions } from 'ag-grid-community';
import { GridViewport } from '../viewport/grid-viewport.interfaces';

export interface GridOptionsExt extends GridOptions {
  viewport?: GridViewport<any>;
  /**
   * Name is used in automation testing in order to distinguish one grid from another.
   */
  name?: string;
  /**
   * This function allows to return id necessary for automation.
   * It is ID that will be injected into data-automation-id attribute
   */
  getRowNodeAutomationId?: GetRowNodeIdFunc;
  /**
   * This options allow to turn off automation.
   */
  noAutomation?: boolean;
}

@Bean('gridOptionsWrapperExt')
export class GridOptionsWrapperExt {
  @Autowired('gridOptions') gridOptionsExt: GridOptionsExt;

  getViewport(): Maybe<GridViewport<any>> {
    return this.gridOptionsExt.viewport;
  }
}
